<app-mens-intimate-wash
  htmlTitle="<strong>Essential: Support Healing</strong> and Manage<br>Outbreaks Effectively"
  question="We highly recommend including the Penile Wash to support healing and reduce the risk of spread or outbreaks. Would you like to add it to your order?"
>
  <p class="mb-4">
    Managing HSV-1 or HSV-2 effectively includes proper care for both yourself and your partner. The virus can linger on
    the skin, increasing the risk of transmission or reinfection, even during asymptomatic periods.
  </p>
  <p class="mb-4">
    Our specially formulated <strong>Penile Wash</strong> is designed to be used by either you or your partner to
    cleanse sensitive areas without causing additional irritation.
    <strong
      >Using this wash can help soothe the skin, remove lingering irritants, and create an environment that supports the
      healing process.</strong
    >
  </p>
</app-mens-intimate-wash>
